
import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const Hotels = () => {

const carouselOneOptions = {
  loop: true,
  margin: 0,
  nav: true,
  dots: true,
  autoplay: true,
  items: 1,
  navText: [
    "<span class='lnr ti-angle-left'></span>",
    "<span class='lnr ti-angle-right'></span>"
  ]
};

  return (
        <>
       
<div className="banner-header-c valign bg-img bg-fixed bg-position-bottom" data-overlay-dark="5" style={{ backgroundImage: `url(img/slider/hotels.webp)` }}>
        <div className="container">
            {/* <div className="row">
                <div className="col-md-12 text-center caption">
                    <h1>Our Residency</h1>
                </div>
            </div> */}
        </div>
        
    </div>
    
    <section className="rooms2 section-padding" data-scroll-index="1">
        <div className="container">
              <div className="row g-0 mb-90">
                <div className="col-md-12 col-lg-5 bg-white order2 valign">
                    <div className="content">
                        <div className="cont">
                            <h3>The Residency - Bodhgaya</h3>
                            <p>Our hotel features 50 serene rooms, offering a peaceful retreat for travelers exploring the region's profound Buddhist heritage. Located at a 5 min walking... </p>
                            <div className="icons-wrapper">
                                <div className="icon"><img src="img/icons/food.webp" loading="lazy" alt="hotel" className="icon-room"/></div>
                                <div className="icon"><img src="img/icons/bed.webp" loading="lazy" alt="hotel" className="icon-room" /></div>
                                <div className="icon"><img src="img/icons/swimming.webp" loading="lazy" alt="hotel" className="icon-room" /></div>
                                <div className="icon"><img src="img/icons/parking.webp" loading="lazy" alt="hotel" className="icon-room" /></div>

                            </div>
                            <div className="book">
                                <div><a href="/Bodhgaya-Residency" className="butn-dark2">View Details</a></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-7 order1">                   
                     <OwlCarousel className="owl-theme first-carousel" {...carouselOneOptions}>
                              <div className="img"> <img src="img/rooms/Bodhgaya.webp" loading="lazy" alt="hotel" /> </div>
                        <div className="img"> <img src="img/rooms/Bodhgaya-1.webp" loading="lazy" alt="hotel" /> </div>
                        {/* <div className="img"> <img src="img/rooms/Bodhgaya-2.webp" loading="lazy" alt="hotel" /> </div> */}
                          </OwlCarousel>
                </div>
            </div>
            <div className="row g-0 mb-90">
                <div className="col-md-12 col-lg-7">
                          <OwlCarousel className="owl-theme first-carousel" {...carouselOneOptions}>
                              <div className="item"><img src="img/rooms/Rajgir.webp" loading="lazy" alt="Room 1" /></div>
                              <div className="item"><img src="img/rooms/Rajgir-1.webp" loading="lazy" alt="Room 2" /></div>
                              <div className="item"><img src="img/rooms/Rajgir-2.webp" loading="lazy" alt="Room 3" /></div>
                          </OwlCarousel>                    
                </div>
                <div className="col-md-12 col-lg-5 bg-white valign">
                    <div className="content">
                        <div className="cont">
                            <h3>The Rajgir Residency</h3>
                            <p>An Exemplary Piece Of Architecture With Well Appointed 83 Rooms And All Modern Amenities Of Comfort And Luxury. Our property has 79 deluxe double and 3 suite rooms.  Located in Rajgir, District Nalanda, Bihar, Our property ...</p>
                            <div className="icons-wrapper">
                              <div className="icon"><img src="img/icons/food.webp" loading="lazy" alt="hotel" className="icon-room" /></div>
                              <div className="icon"><img src="img/icons/bed.webp" loading="lazy" alt="hotel" className="icon-room" /></div>
                              <div className="icon"><img src="img/icons/swimming.webp" loading="lazy" alt="hotel" className="icon-room" /></div>
                              <div className="icon"><img src="img/icons/parking.webp" loading="lazy" alt="hotel" className="icon-room" /></div>
                            </div>
                            <div className="book">
                                <div><a href="/Rajgir-Residency" className='butn-dark2'>View Details</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row g-0 mb-90">
                <div className="col-md-12 col-lg-5 bg-white order2 valign">
                    <div className="content">
                        <div className="cont">
                            <h3>The Vaishali Residency</h3>
                            <p>Nestled in the ancient city of Vaishali, Bihar. Our hotel features 79 comfortable rooms, offering a serene retreat for travelers exploring the region's rich Buddhist heritage.
                                Vaishali, a sacred site in Buddhism...</p>
                            <div className="icons-wrapper">
                              <div className="icon"><img src="img/icons/food.png" loading="lazy" alt="hotel" className="icon-room" /></div>
                              <div className="icon"><img src="img/icons/bed.png" loading="lazy" alt="hotel" className="icon-room" /></div>
                              <div className="icon"><img src="img/icons/swimming.png" loading="lazy" alt="hotel" className="icon-room" /></div>
                              <div className="icon"><img src="img/icons/parking.png" loading="lazy" alt="hotel" className="icon-room" /></div>
                            </div>
                            <div className="book">
                                <div><a href="/Vaishali-Residency" className='butn-dark2'>View Details</a></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-7 order1">                   
                    <OwlCarousel className="owl-theme first-carousel" {...carouselOneOptions}>
                              <div className="img"> <img src="img/rooms/Vaishali.webp" loading="lazy" alt="hotel" /></div>
                        {/* <div className="img"> <img src="img/rooms/Vaishali-1.webp" loading="lazy" alt="hotel" /></div> */}
                        <div className="img"> <img src="img/rooms/Vaishali-2.webp" loading="lazy" alt="hotel" /></div>
                          </OwlCarousel>
                </div>
            </div>
            <div className="row g-0 mb-30">
                <div className="col-md-12 col-lg-7">
                     <OwlCarousel className="owl-theme first-carousel" {...carouselOneOptions}>
                             <div className="img"> <img src="img/rooms/Sravasti.webp" loading="lazy" alt="hotel" /></div>
                        {/* <div className="img"> <img src="img/rooms/Sravasti-1.webp" loading="lazy" alt="hotel" /></div> */}
                        <div className="img"> <img src="img/rooms/Sravasti-2.webp" loading="lazy" alt="hotel" /></div>
                          </OwlCarousel>
                </div>
                <div className="col-md-12 col-lg-5 bg-white valign">
                    <div className="content">
                        <div className="cont">
                            <h3>The Sravasti Residency</h3>
                            <p>A serene haven nestled in the historic city of Sravasti, Uttar Pradesh. Our hotel boasts 56 comfortable rooms, perfect for travelers seeking tranquility... </p>
                              <div className="icons-wrapper">
                                <div className="icon"><img src="img/icons/food.webp" loading="lazy" alt="hotel" className="icon-room" /></div>
                                <div className="icon"><img src="img/icons/bed.webp" loading="lazy" alt="hotel" className="icon-room" /></div>
                                <div className="icon"><img src="img/icons/swimming.webp" loading="lazy" alt="hotel" className="icon-room" /></div>
                                <div className="icon"><img src="img/icons/parking.webp" loading="lazy" alt="hotel" className="icon-room" /></div>

                            </div>
                            <div className="book">
                                <div><a href="/Sravasti-Residency" className='butn-dark2'>View Details</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            

        </div>
    </section>
  
        </>
    )
};

export default Hotels;
